module.exports = __webpack_public_path__ + "img/F1-topImg.76d4f4be.png";